import { Link } from "react-router-dom";
import { motion, useReducedMotion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import IMAGES from "@/data/images";
import { StatusBadge } from "./StatusBadge";
import { DURATION, EASE } from "@/lib/motion";

export const ArticleCard = ({ article, index = 0, feature = false }) => {
  const reduce = useReducedMotion();
  const img = IMAGES[article.image] || IMAGES.heroRidge;

  return (
    <motion.article
      initial={{ opacity: 0, y: reduce ? 0 : 26 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.25 }}
      transition={{ duration: DURATION.editorial, ease: EASE.editorial, delay: Math.min(index * 0.06, 0.3) }}
      className="group"
      data-testid={`article-card-${article.slug}`}
    >
      <Link to={`/journal/${article.slug}`} className="block">
        <div className="ss-hover-grow relative overflow-hidden bg-[#EFECE6] aspect-[4/3]">
          <img
            src={img.url}
            alt={img.alt}
            loading={feature ? "eager" : "lazy"}
            className="h-full w-full object-cover"
          />
          <div className="absolute left-4 top-4">
            <StatusBadge status={article.status} />
          </div>
        </div>
        <div className="pt-5">
          <div className="flex items-center gap-3 mb-3">
            <span className="ss-overline text-[#8C6A53]">{article.category}</span>
            <span className="h-px w-5 bg-[#C8C2B7]" />
            <span className="font-mono-ss text-[0.68rem] tracking-wider text-[#8A9098]">{article.readingTime}</span>
          </div>
          <h3 className={`font-display font-normal leading-snug text-[#1A1C1E] ${feature ? "text-2xl sm:text-3xl" : "text-xl sm:text-2xl"}`}>
            {article.title}
          </h3>
          <p className="mt-3 text-[0.95rem] leading-relaxed text-[#52575D] line-clamp-3 font-light">
            {article.summary}
          </p>
          <span className="mt-4 inline-flex items-center gap-1.5 text-[0.78rem] uppercase tracking-[0.1em] text-[#1A1C1E]">
            <span className="ss-link">Read intelligence</span>
            <ArrowUpRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" strokeWidth={1.5} />
          </span>
        </div>
      </Link>
    </motion.article>
  );
};

export default ArticleCard;
